
import { Box, Typography, CircularProgress } from '@mui/material';

const TimerProgressCircle = ({
  value = 100,
  size = 100,
  thickness = 4,
  label = '00:00',
  textVariant="caption",
  onClick,
  actionIcon = null,
  actionLabel,
}) => {
  const isInteractive = typeof onClick === 'function';

  const handleKeyDown = (event) => {
    if (!isInteractive || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    onClick();
  };

  return (
    <Box
      position="relative"
      display="inline-flex"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      aria-label={isInteractive ? actionLabel : undefined}
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        cursor: isInteractive ? 'pointer' : 'default',
        background: 'radial-gradient(circle, rgba(0,229,255,0.09) 0%, rgba(0,229,255,0.03) 52%, transparent 72%)',
        filter: 'drop-shadow(0 0 9px rgba(0, 229, 255, 0.42))',
        transition: 'transform 160ms ease, filter 160ms ease',
        '&:hover': isInteractive ? {
          transform: 'translate(-2px, -2px)',
          filter: 'drop-shadow(0 0 14px rgba(0, 229, 255, 0.58))',
        } : undefined,
        '&:active': isInteractive ? {
          transform: 'translate(1px, 1px)',
        } : undefined,
        '&:focus-visible': isInteractive ? {
          outline: '3px solid',
          outlineColor: 'primary.main',
          outlineOffset: 4,
        } : undefined,
      }}
    >
      <CircularProgress
        variant="determinate"
        value={value}
        size={size}
        thickness={thickness}
        style={{ transform: 'rotate(-90deg)', transformOrigin: 'center' }}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={1.5}
      >
        <Typography variant={textVariant} component="div" color="text.secondary">
          {label}
        </Typography>
        {actionIcon && (
          <Box
            aria-hidden="true"
            sx={{
              width: 48,
              height: 38,
              display: 'grid',
              placeItems: 'center',
              color: 'background.default',
              bgcolor: 'primary.main',
              borderRadius: 999,
              boxShadow: '0 5px 0 #007785, 0 0 14px rgba(0, 229, 255, 0.45)',
            }}
          >
            {actionIcon}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TimerProgressCircle;
